import { AxiosResponse } from 'axios'
import { RequestREAD, RequestCDU } from 'services/Instances'

const WalletNGTServices = () => {
  const path = 'Carteira'

  const SearchWallet = async (
    params: ISearchWalletParams
  ): Promise<AxiosResponse<ISearchWalletResponse>> =>
    await RequestREAD.get(`${path}/Pesquisar`, { params })

  const GetCarteirasAnoMesCompetencia = async (
    params: IWalletYearMonthCompetenceRequest
  ): Promise<AxiosResponse<IWalletYearMonthCompetenceResponse>> =>
    await RequestREAD.get(`${path}/GetCarteirasCriadasPorAnoMesCompetencia`, {
      params
    })

  return { GetCarteirasAnoMesCompetencia, SearchWallet }
}

const WalletItemServices = () => {
  const path = 'Cre'

  const designateAnalyst = async (
    requestObj: IWalletItem
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/DesignarAnalista`, requestObj)

  const verificarDisponibilidadeCre = async (
    obj: number[]
  ): Promise<AxiosResponse<IResponseGetStatusOcupado>> =>
    await RequestREAD.post(path + '/GetStatusOcupado', obj)

  return { designateAnalyst, verificarDisponibilidadeCre }
}

export interface IWalletItem {
  usuarioId: number
  cresIds: number[]
}

export interface IWalletYearMonthCompetenceResponse {
  entity: {
    cresIds: number[]
    gridItens: {
      pageCount: number
      totalItemCount: number
      pageNumber: number
      pageSize: number
      hasPreviousPage: boolean
      hasNextPage: boolean
      isFirstPage: boolean
      isLastPage: boolean
      firstItemOnPage: number
      lastItemOnPage: number
      items: IManageWalletTable[]
    }
  }
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

export interface IWalletRequest {
  DataAtual: string
  PageNumber: number
  PageSize: number
  SearchQuery: string
  primeiraMob: boolean
  UltMed: boolean
  Denuncia: boolean
  Projeto: boolean
  Alerta: boolean
  Todos?: boolean
}

export interface IWalletYearMonthCompetenceRequest {
  DataAtual?: string
  PageNumber: number
  PageSize: number
  SearchQuery: string
  PrimeiraMob?: boolean
  UltMed?: boolean
  Denuncia?: boolean
  Projeto?: boolean
  Alerta?: boolean
  Todos?: boolean
  Paginacao?: boolean
  CheckAll?: boolean
}

export interface ISearchWalletParams {
  CdContrato: string
  NmFornecedor: string
  NuAnoMesCompetenciaInicial: string
  NuAnoMesCompetenciaFinal: string
  CdCRE: string
  NmAnalista: string
  DtAnalise: string
  DtUltimaAnalise: string
  FlMobilizacao: boolean
  FlMedicao: boolean
  FlDenuncia: boolean
  FlProjeto: boolean
  FlAlerta: boolean
  flTodos: boolean
  PageNumber: number
  PageSize: number
}

export interface Item {
  creId: number
  idMovimentacao: number
  idContrato: number
  idFornecedor: number
  codigoContrato: string
  nomeFornecedor: string
  nuAnoMesCompetencia: string
  flPrimeiraMobilizacao: boolean
  flUltMedicao: boolean
  flDenuncia: boolean
  flProjeto: boolean
  flAlerta: boolean
  codigoCRE?: any
  nomeAnalista: string
  vlFolha: number
  dtUltAnaliseCRE: Date
  slaDtAnalise: Date
  vlSla: number
  txStatusColor: string
  flPendente: boolean
  flAnexado: boolean
  qtItensAnexados: number
  cdCentro?: string
}

export interface ISearchWalletResponse {
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
  items: Item[]
}

export interface IManageWalletTable {
  anoMesCompetencia: number
  carteiraItemId: number
  cdContrato: string
  checked: boolean
  codCre: string
  contratoId: number
  creDisponivel: boolean
  creId: number
  dtAnalise: string | Date
  dtLiberacaoCre: string | Date
  dtUltAnaliseCRE: string | Date
  flAlerta: boolean
  flDenuncia: boolean
  flLegado: boolean
  flPrimeiraMob: boolean
  flProjeto: boolean
  flUltMedicao: boolean
  fornecedorId: number
  hasItem: boolean
  movimentacaoId: number
  nmAnalista: string
  nmFornecedor: string
  qtTotalEfetivo: number
  slaDtAnalise: string
  slaDtArqAnexado: string | Date
  slaDtRetorno: string | Date
  slaVencido: boolean
  txStatusColor: string
  vlFolhaPagto: number
  vlSla: number
  dtAnexo: string | Date
  cdCentro: string
}

export interface IGetStatusOcupadoItems {
  idCre: number
  creOcupado: boolean
  nomeAnalista: string
  dataAnalise: string | Date
  status: string
  codigoCRE: string
}

export interface IResponseGetStatusOcupado {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
  entity: IGetStatusOcupadoItems[]
}

export { WalletNGTServices, WalletItemServices }

//
